import { languagesAvailable } from "src/context/Translations/interface";
import * as yup from "yup";

const mountObj = (msg: string) => {
	const obj: any = {};
	languagesAvailable.forEach((lng) => {
		obj[lng] = yup.string().required(msg);
	});
	return obj;
};

const notificationsSchema = (translate: Function) => yup.object().shape({
	efn001Tipo: yup.string().required(translate("Tipo é requerido")),
	efn001Mostrar: yup.number().required(translate("Mostrar para é requerido")),
	efn001Dtinicial: yup.date()
		.required(translate("Data inicial é requerida"))
		.typeError(translate("Data inicial inválida")),
	efn001Dtfinal: yup.date()
		.required(translate("Data final é requerida"))
		.typeError(translate("Data final inválida"))
		.when("efn001Dtinicial",(initialDate,schema) => initialDate && schema.min(initialDate,translate("Data final não pode ser menor que a inicial"))),
	efn001Msgsimples: yup.object().shape(mountObj(translate("Título é requerido"))),
	efn001Msgcompleta: yup.object().shape(mountObj(translate("Mensagem é requerida")))
});

export default notificationsSchema;
